import React, {useState, useContext, useEffect, useCallback} from 'react';
import {Button, setOptions} from "@mobiscroll/react";
import '@mobiscroll/react/dist/css/mobiscroll.min.css';
import {Listview} from '@mobiscroll/react4';
import '@mobiscroll/react4/dist/css/mobiscroll.min.css';
import '../styles/queueIn.css';
import dayjs from "dayjs";
import {
    faArrowUpShortWide,
    faAt,
    faMobileScreenButton,
    faArrowDownWideShort,
    faCirclePhone,
    faBrainCircuit,
    faClipboardList,
    faUserPlus,
    faPipe
} from "@fortawesome/pro-duotone-svg-icons";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import Empty from "../utils/Empty";
import User from "../utils/User";
import Loading from "../utils/Loading";
import {NetworkContext} from "../utils/NetworkContext";

setOptions({
    theme: 'ios',
    themeVariant: 'light',
});

function QueueIn({locale, Dialog, setVisit, location, setPatient, width}) {
    const {wsCall, wsResponse, setWsResponse} = useContext(NetworkContext);
    const [queueIn, setQueueIn] = useState([]);
    const [loading, setLoading] = useState(true);
    const [sort, setSort] = useState(true);
    const [iconHover, setIconHover] = useState(null);

    const Queue = data => {
        const message = {
            type: 'wss',
            path: 'queue',
            action: 'get',
            data: {
                status: 'in',
                location: location
            }
        };
        wsCall(message);
    }

    const ButtonSort = () => {
        if (!sort) {
            const array = queueIn;
            array.reverse();
            setQueueIn(array);
            setSort(true);
        } else {
            const array = queueIn;
            array.reverse();
            setQueueIn(array);
            setSort(false);
        }
    }

    const ClickOpen = data => {
        setVisit(data);
        Dialog({view: 'queueVisit', tab: 'visit'});
    }

    const ButtonPatient = data => {
        setVisit(data);
        setPatient({});

        const message = {
            type: 'wss',
            path: 'patient',
            action: 'get',
            data: {
                patient: data.user,
                source: 'queueIn'
            }
        };
        wsCall(message);
    }

    const ListItem = data => {
        const itemDate = dayjs(parseInt(data.item.timestampIn)).format("MMMM D, YYYY @ h:mm A");

        return <li key={data.item.timestampIn}>
            <div className="mbsc-row">
                <div className="mbsc-col">
                    <div className="mbsc-row cs-queue-in-list" onClick={() => ClickOpen(data.item)}>
                        {width > 576 && data.item.type === 'mobile' &&
                            <FontAwesomeIcon className="cs-queue-in-list-icon-mobile" icon={faMobileScreenButton} />
                        }
                        {width > 576 && data.item.type === 'whatsapp' &&
                            <FontAwesomeIcon className="cs-queue-in-list-icon-whatsapp" icon={faCirclePhone} />
                        }
                        {width > 576 && data.item.type === 'email' &&
                            <FontAwesomeIcon className="cs-queue-in-list-icon-email" icon={faAt} />
                        }
                        <div className="cs-queue-in-list-section">
                            <div className="mbsc-bold mbsc-txt-muted">
                                {data.item.firstName && data.item.firstName} {data.item.middleName && data.item.middleName} {data.item.lastName && data.item.lastName} {data.item.paternalName && data.item.paternalName} {data.item.maternalName && data.item.maternalName} {width > 992 && <FontAwesomeIcon className="cs-queue-in-icon-pipe-xs" icon={faPipe} />} {width > 992 && User(data.item)} {data.item.triage.length !== 0 && <FontAwesomeIcon className="cs-queue-in-icon-info" icon={faBrainCircuit} />}{data.item.firstVisit && <FontAwesomeIcon className="cs-queue-in-icon-info" icon={faUserPlus} />}
                            </div>
                            <div className="mbsc-row mbsc-txt-muted mbsc-txt-s cs-queue-in-item-txt">
                                {width > 992 && locale.queueIn.f} {itemDate}
                            </div>
                        </div>
                    </div>
                </div>
                <div className="mbsc-col-auto cs-queue-in-list-button">
                    <Button color="primary" variant="flat" className="mbsc-bold" onClick={() => ButtonPatient(data.item)} >
                        <FontAwesomeIcon className="cs-queue-in-icon-right" icon={faClipboardList} />
                    </Button>
                </div>
            </div>
        </li>;
    }

    const GetQueue = useCallback(data => {
        if (data.queue) {
            setQueueIn(data.queue);
        }
        if (loading) {
            setLoading(false);
        }
    }, [loading]);

    useEffect(() => {
        if (wsResponse && !Empty(wsResponse) && wsResponse.action === 'get' && wsResponse.path === 'queue') {
            GetQueue(wsResponse.data);
            setWsResponse({});
        }
    }, [wsResponse, GetQueue, setWsResponse]);

    useEffect(() => {
        Queue();
    }, []);

    return (
        <>
            <div className={width > 768 ? "mbsc-row cs-queue-in-menu" : "mbsc-row cs-queue-in-menu-xs"}>
                <div className="mbsc-col" />
                <div className="mbsc-col-auto">
                    <div className="mbsc-row">
                        <Button onMouseEnter={() => setIconHover('sort')} onMouseLeave={() => setIconHover(null)} disabled={queueIn.length === 0} color="primary" variant="flat" className="mbsc-bold cs-queue-in-button-text" onClick={() => ButtonSort()} >
                            <FontAwesomeIcon className="cs-queue-in-icon" icon={sort ? faArrowUpShortWide : faArrowDownWideShort} beatFade={iconHover === 'sort'} /> {width > 768 && locale.queueIn.b}
                        </Button>
                    </div>
                </div>
            </div>
            {loading &&
                <div className="mbsc-padding" >
                    <Loading />
                </div>
            }
            {queueIn.length === 0 && !loading &&
                <div className="mbsc-row mbsc-justify-content-center cs-queue-in-section">
                    <div className="mbsc-padding">
                        <p className="mbsc-bold mbsc-txt-muted">{locale.queueIn.a}</p>
                    </div>
                </div>
            }
            {queueIn.length !== 0 && !loading &&
                <Listview
                    theme="ios"
                    themeVariant="light"
                    select="single"
                    itemType={ListItem}
                    data={queueIn}
                />
            }
        </>
    );
}

export default QueueIn;
